/* Privacy / Terms / Refund / Contact. */

/* ----------------------------------------------- the sign-in page footer */

/*
  Under the card, not inside it: these are not part of signing in, and a row
  of four links inside the box competes with the submit button.
*/
.footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-2) var(--space-4);
  margin-top: var(--space-5);
}

.footerLink {
  font-size: var(--text-xs);
  color: var(--text-muted);
  text-decoration: underline;
  text-underline-offset: 2px;
  /* A legal link must stay tappable on a phone without growing the row. */
  padding: var(--space-1) 0;
}

.footerLink:hover {
  color: var(--text);
}

/* --------------------------------------------------- the portal group */

.group {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.groupTitle {
  margin: 0;
  font-size: var(--text-xs);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-subtle);
}

.list {
  display: grid;
  gap: var(--space-2);
  /* Two across on a wide screen, one on a phone — four tiles in a column
     is a lot of height for links nobody opens twice. */
  grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
  margin: 0;
  padding: 0;
  list-style: none;
}

.tile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  font-size: var(--text-base);
  color: var(--text);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  text-decoration: none;
  transition:
    border-color var(--transition-fast),
    background var(--transition-fast);
}

.tile:hover {
  border-color: var(--border-strong);
  background: var(--bg-hover);
}

.tileIcon {
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  color: var(--text-subtle);
}

@media (prefers-reduced-motion: reduce) {
  .tile {
    transition: none;
  }
}
